import React, { useState, useEffect, useContext } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid, Snackbar, Alert
} from "@mui/material";
import { ThemeContext } from "../../../../../../../../context/ThemeContextProvider";
import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext";

const EditOrderForm = ({ open, onClose, initialData }) => {
  const { mode } = useContext(ThemeContext);
  const { updateOrderData } = useOrder(); // ✅ جلب الدالة من الـ Context

  const [form, setForm] = useState({});
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (initialData) setForm(initialData);
  }, [initialData]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (!form.order_id) throw new Error("❌ رقم الأوردر غير موجود");

      const updateData = {
        customer_name: form.customer_name,
        customer_phone1: form.customer_phone1,
        customer_phone2: form.customer_phone2,
        customer_phone3: form.customer_phone3,
        customer_address1: form.customer_address1,
        customer_address2: form.customer_address2,
        customer_id: form.customer_id || (form.customer?.id ?? ""),
        table_id: form.table_id || "",
      };

      // ✅ استخدم الدالة من الـ Context
      await updateOrderData(form.order_id, updateData);

      setSuccess(true);
      onClose(true);
    } catch (err) {
      let msg = "فشل في تعديل الأوردر: ";
      if (err?.message) msg += err.message;
      setError(msg);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
            borderRadius: 3,
          },
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 700,
              fontSize: 22,
              textAlign: "center",
              color: "#EA7C69",
              bgcolor: mode === "dark" ? "#181824" : "#fff",
              borderRadius: "16px 16px 0 0",
            }}
          >
            تعديل بيانات العميل
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              pb: 2,
            }}
          >
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="اسم العميل"
                  name="customer_name"
                  value={form.customer_name || ""}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="هاتف 1"
                  name="customer_phone1"
                  value={form.customer_phone1 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="هاتف 2"
                  name="customer_phone2"
                  value={form.customer_phone2 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="هاتف 3"
                  name="customer_phone3"
                  value={form.customer_phone3 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="العنوان 1"
                  name="customer_address1"
                  value={form.customer_address1 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="العنوان 2"
                  name="customer_address2"
                  value={form.customer_address2 || ""}
                  onChange={handleChange}
                  variant="outlined"
                  sx={{
                    bgcolor: mode === "dark" ? "#181824" : "#fff",
                    borderRadius: 2,
                    input: { color: mode === "dark" ? "#fff" : "#232334" },
                    label: { color: mode === "dark" ? "#aaa" : undefined },
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ bgcolor: mode === "dark" ? "#232334" : "#fff", borderRadius: "0 0 16px 16px" }}>
            <Button
              onClick={() => onClose(false)}
              variant="outlined"
              color="secondary"
              sx={{
                minWidth: 100,
                borderColor: mode === "dark" ? "#888" : undefined,
                color: mode === "dark" ? "#fff" : undefined,
              }}
            >
              إلغاء
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{
                bgcolor: "#EA7C69",
                color: "#fff",
                minWidth: 120,
                fontWeight: 700,
                "&:hover": { bgcolor: "#d45d4c" },
              }}
            >
              حفظ التعديلات
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Snackbar open={!!error} autoHideDuration={3000} onClose={() => setError("")}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
        <Alert severity="success">✅ تم التعديل بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditOrderForm;
